export default "__VITE_ASSET__XrByIebm__"